module.exports = __webpack_public_path__ + "static/media/Private Road 5.5fa95892.jpg";